<template>
  <div class="gWidth soccer_box">
    <!-- 选项卡 -->
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-for="(item, index) in sclassList"
        :key="index"
        :label="item.info_type_name"
        :name="item.info_type_name"
      >
        <!-- 选项卡内容 -->
        <div class="soccer_xbox">
          <!-- 字内容 -->
          <div
            class="soccer_xbox_item"
            v-for="(i, index) in item.country_list"
            :key="index"
          >
            <router-link
              :to="{
                name: 'schedule',
                params: { sclassId: i.sclass_list[0].sclass_id },
              }"
            >
              <el-image
                :src="i.flag_pic ? `${$imgUrl + '/info/' + i.flag_pic}` : ''"
              ></el-image>
            </router-link>
            <el-dropdown placement="bottom" size="mini">
              <span class="el-dropdown-link">
                <span>{{ i.name_cn }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <ul class="xl_ul">
                    <li
                      v-for="(ii, index) in i.sclass_list"
                      :command="ii.sclass_id"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'schedule',
                          params: { sclassId: ii.sclass_id },
                        }"
                      >
                        {{ ii.name_js }}
                      </router-link>
                    </li>
                  </ul>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getCurrentInstance, ref } from "vue";
export default {
  setup() {
    let { proxy: _this } = getCurrentInstance();
    let sclassList = ref([]);
    let activeName = ref("欧洲赛事");
    let getSclassInfo = async () => {
      let { data: res } = await _this.$http.get("soccer/sclass");
      if (res.code === 200) sclassList.value = res.data;
    };
    getSclassInfo();

    return {
      activeName,
      sclassList,
    };
  },
};
</script>
<style lang="less" scoped>
.xl_ul {
  width: 300px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  li {
    width: 100px;
    line-height: 20px;
    text-align: center;
    &:hover {
      background: #ecf5ff;
    }
    &:hover a {
      color: #66b1ff;
    }
    a {
      font-size: 14px;
      width: 100%;
      display: inline-block;
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  /* color: #409eff; */
  color: #909399;
  display: flex;
  align-items: center;
  span {
    max-width: 70px;
    display: inline-block;
    overflow: hidden; /*溢出的部分隐藏*/
    white-space: nowrap; /*文本不换行*/
    text-overflow: ellipsis;
  }
  &:hover {
    color: #409eff;
  }
}
.el-icon-arrow-down {
  font-size: 12px;
}

.soccer_box {
  /* background: #fff; */
  .el-tabs {
    padding: 20px;
    background: #fff;
    .soccer_xbox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .soccer_xbox_item {
        width: 100px;
        margin-left: 26px;
        margin-bottom: 10px;
        border: 1px solid #eee;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 6px 0;
        &:hover {
          background: #eef8ff;
        }
        &:hover .el-dropdown-link {
          color: #409eff;
        }
        a {
          display: flex;
          width: 70px;
          height: 70px;
          justify-content: center;
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>
